// src/boot-theme.js
// Roda cedo para evitar "flash" de tema e ativar efeitos do header
(function () {
  try {
    // ---------- Tema ----------
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const theme = (saved === 'dark' || saved === 'light') ? saved : (prefersDark ? 'dark' : 'light');

    // Aplica no <html> (data-theme) e compat no <body>
    document.documentElement.setAttribute('data-theme', theme);
    const applyBodyMode = () => {
      document.body.classList.toggle('dark-mode', theme === 'dark');
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyBodyMode, { once: true });
    } else {
      applyBodyMode();
    }

    // ---------- Header "glass" on scroll ----------
    const onScroll = () => {
      const header = document.querySelector('header.header');
      if (!header) return;
      header.classList.toggle('is-scrolled', (window.scrollY || 0) > 4);
    };
    // Inicializa e escuta
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onScroll, { once: true });
    } else {
      onScroll();
    }
    document.addEventListener('scroll', onScroll, { passive: true });
  } catch (e) { /* no-op */ }
})();
